/* MYNTELO v7 A.6 custom cursor: desktop fine pointers only. One pointermove + one idle-cancelling rAF loop. */
(function(){
  var w=window,d=document,R=d.documentElement,S={active:false};
  w.__mynCursor=S;
  function mq(q){return !!(w.matchMedia&&w.matchMedia(q).matches)}
  if(!mq('(hover: hover) and (pointer: fine)')||mq('(prefers-reduced-motion: reduce)')||(w.Shopify&&w.Shopify.designMode)||location.pathname.indexOf('/checkouts')===0||!d.body)return;
  var LINK='a,button,[role=button],label,summary,input[type=submit]',
    TEXT='input:not([type=submit],[type=button],[type=checkbox],[type=radio],[type=range],[type=color],[type=file],[type=image],[type=reset]),textarea,select,[contenteditable]:not([contenteditable=false]),iframe',
    SPIN='.m3d__stage,.m3x__stage';
  function mk(c,h){var e=d.createElement('i');e.className='myn-cur myn-cur--'+c;e.setAttribute('aria-hidden','true');if(h)e.innerHTML=h;d.body.appendChild(e);return e}
  var dot=mk('dot','<i class="myn-cur__sq"></i><svg class="myn-cur__hand" viewBox="0 0 20 20" width="20" height="20"><path d="M7.5 1.8c.9 0 1.6.7 1.6 1.6v5.1c.8-.3 1.8 0 2.1.8.8-.4 1.9-.1 2.2.8.9-.4 2.2.2 2.2 1.3v3.4c0 2.5-2 4.4-4.4 4.4H9.4c-1.4 0-2.7-.7-3.5-1.8l-2.6-3.7c-.5-.7-.3-1.6.4-2.1.6-.4 1.4-.3 1.9.2l.3.4V3.4c0-.9.7-1.6 1.6-1.6z" fill="#fff" stroke="#101519" stroke-width="1.2" stroke-linejoin="round"/></svg><span class="myn-cur__lbl">Drag to spin</span>'),
    tx=mk('x'),ty=mk('y'),els=[dot,tx,ty],
    x=0,y=0,px=-1,py=-1,raf=0,last=0,st='';
  function setState(s){if(s===st)return;for(var i=0;i<3;i++){if(st)els[i].classList.remove('is-'+st);if(s)els[i].classList.add('is-'+s)}st=s}
  function draw(){if(x===px&&y===py)return;px=x;py=y;
    dot.style.transform='translate3d('+x+'px,'+y+'px,0)';
    tx.style.transform='translate3d('+x+'px,0,0)';
    ty.style.transform='translate3d(0,'+y+'px,0)'}
  function tick(t){draw();if(t-last>200){raf=0;return}raf=requestAnimationFrame(tick)}
  function off(){R.classList.remove('myn-cursor')}
  d.addEventListener('pointermove',function(e){
    if(e.pointerType==='touch'){off();return}
    x=e.clientX;y=e.clientY;last=performance.now();
    if(!R.classList.contains('myn-cursor')){draw();R.classList.add('myn-cursor')}
    if(!raf)raf=requestAnimationFrame(tick)
  },{passive:true});
  d.addEventListener('pointerover',function(e){var t=e.target;if(!t||!t.closest)return;
    setState(t.closest(TEXT)?'text':t.closest(LINK)?'link':t.closest(SPIN)?'spin':'')},{passive:true});
  d.addEventListener('pointerout',function(e){if(!e.relatedTarget)off()},{passive:true});
  d.addEventListener('focusin',function(e){var t=e.target;if(t&&t.matches&&t.matches(TEXT))setState('text')});
  R.addEventListener('pointerleave',off);
  d.addEventListener('visibilitychange',function(){if(d.hidden)off()});
  S.active=true;
})();
